<template>
  <div class="season">

    <div class="top">
      <back-button></back-button>
      <router-link class="button" :to="{path:'allmedia'}">VIEW ALL MEDIA</router-link>
    </div>

    <!-- <header>
      <div class="header-copy grid-item">
        <h1>{{ exhibit.name }}</h1>
      </div>
    </header> -->


    <a-scene vr-mode-ui="enabled: false">


      <!-- Camera + cursor.
        https://github.com/dmarcos/aframe/blob/master/docs/components/cursor.md
        cursor="rayOrigin: mouse"

        fuseTimeout:400;
        downEvents:[triggerdown]
        fuse:false; downevents=[triggerdown]

        defaults to true either way
        mouseCursorStylesEnabled:true;
        ; downEvents:[click, mousedown,touchstart,triggerdown]
     -->
    <a-entity id="#rig" position="0 1.6 0" >
      <a-entity camera far="10000" look-controls cursor="rayOrigin:mouse; fuseTimeout:40"/>
    </a-entity>

      <!-- Assets to bind to primitives -->
      <a-assets>
        <img
          v-for="(image,index) in galleries"
          crossorigin="anonymous"
          :key="index"
          :id="getID(image.season)"
          :src="image.panorama_image">
      </a-assets>

      <!--
        event-set__click="_event: click;"
        cursor="fuse: false;" -->
      <a-cylinder
        v-for="(pin,p) in getActivePins"
        :key="p"
        :position="setPosition(pin.horizontal, pin.vertical, pin.zoom)"
        :rotation="getRotation(pin.zoom, pin.face_direction)"
        :src="getMediaIcon(pin.pin_type)"
        radius="0.5"
        height="0.1"
        color="#ffffff"
        raycaster="far: 20; interval: 1000; objects: .clickable"
        @mousedown="onClickPin(pin)" />
        <!-- animation__click="property: scale; startEvents: click; easing: easeInCubic; dur: 150; from: 0.1 0.1 0.1; to: 1 1 1"
        animation__fusing="property: scale; startEvents: fusing; easing: easeInCubic; dur: 1500; from: 1 1 1; to: 0.1 0.1 0.1"
        animation__mouseleave="property: scale; startEvents: mouseleave; easing: easeInCubic; dur: 500; to: 1 1 1"
        cursor -->


      <!-- 360-degree image -->
      <a-sky ref="skyBack" id="sky-back" radius="10" :src="getActiveSeasonID" opacity="1"></a-sky>
      <a-sky ref="skyFront" id="sky-front" radius="10" :src="getPreviouslyActiveSeasonID" opacity="0"></a-sky>

    </a-scene>

    <div id="season-btns">
      <button :disabled="busy || currentlyActiveSeason===1" :class="{active:currentlyActiveSeason===1}" id="btn-spring" @click="onSeasonButton(1)">Spring</button>
      <button :disabled="busy || currentlyActiveSeason===2" :class="{active:currentlyActiveSeason===2}" id="btn-summer" @click="onSeasonButton(2)">Summer</button>
      <button :disabled="busy || currentlyActiveSeason===3" :class="{active:currentlyActiveSeason===3}" id="btn-fall" @click="onSeasonButton(3)">Fall</button>
    </div>

    <dialogue
      class="modal"
      v-show="showModal"
      :type="modaltype"
      :media="modalurl"
      @close-dialogue="onCloseDialogue">
      <p v-html="getCaption" />
    </dialogue>

    <div class="debug" v-if="debug">
      <h6>Pins</h6>
      <!-- <p>{{pinTypes}}</p> -->
      <!-- <p>{{getActivePins}}</p> -->

      <ul>
        <li v-for="(pin,p) in getActivePins" :key="p">
          <!-- {{pin}} -->
          :key="{{p}}"
          :position="{{setPosition(pin.horizontal, pin.vertical, pin.zoom)}}"
          :rotation="{{getRotation(pin.zoom, pin.face_direction)}}"
          :src="{{getMediaIcon(pin.pin_type)}}"
        </li>
      </ul>
<!--
      <h6>Cylinders</h6>
      <ul>
        <li v-for="(cylinder,i) in cylinders" :key="i">{{cylinder}}</li>
      </ul>

      <h6>Seasons</h6>
      <p>Active : {{getActiveSeason}}</p>
      <p>{{seasons}}</p>
      <p>{{pins}}</p>

      <h6>Pin Data</h6>
      <p>{{springPins}}</p>
      <p>{{summerPins}}</p>
      <p>{{fallPins}}</p>
      <p>{{winterPins}}</p>

      <h6>Exhibition Data</h6>
      <p>{{exhibitdata}}</p>
      <p v-for="(data,index) in exhibitdata" :key="index">{{data}}</p> -->
    </div>

  </div>
</template>

<script>
import Vue from 'vue'
// import AFrame from 'aframe'

import Dialogue from './Dialogue'
import { tween } from 'shifty'

// This prevents IOSX from freaking out through VueJS errors
Vue.config.ignoredElements = ['a-scene','a-entity', 'a-sky','a-assets','a-cylinder']
//Vue.use(AFrame)

// Season IDs
const SEASON_SPRING = 1
const SEASON_SUMMER = 2
const SEASON_FALL = 3
const SEASON_WINTER = 4

// Pin IDs
const PIN_IMAGE = 1
const PIN_VIDEO = 2
const PIN_AUDIO = 3

// Icons
const ICON_IMAGE = "static/img/icons/optimised/hs-photo.png"
const ICON_VIDEO = "static/img/icons/optimised/hs-video.png"
const ICON_AUDIO = "static/img/icons/optimised/hs-audio.png"
const ICONS = [null,ICON_IMAGE,ICON_VIDEO,ICON_AUDIO]

export default {

  name: 'Seasons',

  // attributes that get set on the html where this vue component is initialised
  // in this case, all of these props are being satisfied by the router
  props: {
    exhibitslug:{
      type:String,
      default:''
    },
    debug:{
      type:Boolean,
      default:false
    }
  },
  data () {
    return {
      x: 0, y: -2, z: -9, a: 180, b: 270, c: 90,
      //summerPins: [], springPins: [], fallPins: [], winterPins: [],
      previouslyActiveSeason: 1,
      currentlyActiveSeason: 1,
      showModal:false,
      busy:false,

      modaltype:PIN_IMAGE,
      modalurl:'',
      modalCaption:'',


      // holder of all the data required for the cylinders
      cylinders:[],
      // hold all pins in the format of pin.season.arrayOfPins
      pins:{

      },
      // different types of pins
      pinTypes:{
        image:PIN_IMAGE,
        video:PIN_VIDEO,
        audio:PIN_AUDIO
      },
      // different types of seasons
      seasons:{
        spring:SEASON_SPRING,
        summer:SEASON_SUMMER,
        fall:SEASON_FALL,
        winter:SEASON_WINTER
      }
    }
  },

  // This is a VUE specific way of creating data vars that cache
  computed: {

    exhibits () {
      return this.$store.state.exhibits
    },
    exhibit () {
      return this.exhibits[this.exhibitid]
    },
    exhibitdata () {
      return this.$store.state.exhibit_data[this.exhibitid]
    },
    galleries () {
      return this.exhibitdata.galleries
    },
    exhibitid () {
      return this.$store.state.exhibitnames[this.exhibitslug]
    },

    getPosition () {
      return `${this.x} ${this.y} ${this.z}`
    },

    getActiveSeason(){
      return this.getNameOfSeason(this.currentlyActiveSeason)
    },
    getActiveSeasonID(){
      return this.getSeasonID(this.currentlyActiveSeason)
    },

    getPreviouslyActiveSeason(){
      return this.getNameOfSeason(this.previouslyActiveSeason)
    },
    getPreviouslyActiveSeasonID(){
      return this.getSeasonID(this.previouslyActiveSeason)
    },

    // Return all pins that match this season...
    getActivePins(){
      return this.pins[this.currentlyActiveSeason]
    },

    getCaption(){
      return this.modalCaption || this.getActiveSeason
    }
  },

  // Paramatised versions of the computed properties
  methods: {

    // Fetch the rotation of this skybox
    getRotation(zoom, face_direction){
      // not keen on this approach
      /*if (zoom > -1) {
        this.a = 0
      } else {
        this.a = 180
      }
      return `${this.a} ${this.b} ${this.c}`*/
      if (zoom > -1) {
        return `${0} ${face_direction} ${90}`
      } else {
        return `${180} ${face_direction} ${90}`
      }
    },

    getMediaIcon(pinType){
      return ICONS[pinType]
    },

    // Season Name
    getNameOfSeason(index){
      switch(parseInt(index))
      {
        case SEASON_SPRING: return 'spring'
        case SEASON_SUMMER: return 'summer'
        case SEASON_FALL: return 'fall'
        case SEASON_WINTER: return 'winter'
      }
    },
    getID( index, prefix="img-" ) {
      return `${prefix}${this.getNameOfSeason(index)}`
    },
    getSeasonID(season, prefix="img-", hash="#"){
      return `${hash}${this.getID(season,prefix)}`
    },

    // Take the data and create our data arrays...
    parseData(){

      let galleries = this.exhibitdata.galleries

      this.currentlyActiveSeason
      this.cylinders = []
      this.pins = {}

      for (let x = 0; x < galleries.length; x++)
      {
        const gallery = galleries[x]
        const season = parseInt(gallery.season)

        if (gallery.panorama_image)
        {
          this.pins[season] = gallery.pin_locations
        }else{
          // invalid CMS entry
        }
      }
    },

    /*
    *This changes the pins opacity
    *Vue is reactive for data props
    *This reactive property changes the toggled pins
    */
    togglePins(season){
      if(season === this.currentlyActiveSeason){
        return true
      }else{
        return false
      }
    },
    transitionSkies(){
      const back = this.$refs.skyBack
      const front = this.$refs.skyFront

      let started = false
      this.busy = true

      tween({
        from: { opacity: 0 },
        to: { opacity: 1 },
        duration: 1500,
        easing: 'linear',
        step: state => {
          if (!started){
            front.setAttribute('opacity',1)
            started = true
          }
          const opacity = state.opacity
          //const inverse = 1 - opacity
          // here state is changing
          back.setAttribute('opacity',opacity)
          //front.setAttribute('opacity',inverse)
          /*console.log('opacity change',{opacity, inverse})*/
        }
      }).then(
        () => {
          //console.log('transition completed')
          front.setAttribute('opacity',0)
          this.busy = false
        }
      );
      /*console.log('opacities', {back:back.getAttribute('opacity'),front:front.getAttribute('opacity')})*/
    },
    distance (id) {
      return Math.round(this.$store.state.distances[id] * 3.2808)
    },
    link (id) {
      return { name: 'exhibit', params: { exhibitid: id } }
    },
    setPosition (x = '', y = '', z = '') {
      // if (x) { this.x = parseInt(x) }
      // if (y) { this.y = parseInt(y) }
      // if (z) { this.z = parseInt(z) }
      // return `${this.x} ${this.y} ${this.z}`
      // for some reason called, "Vue sideEffects", the above code
      // is cause infinite loop issues which is crashing the application
      // So we hope no one would be dumb enough not to set properties
      return `${parseInt(x)} ${parseInt(y)} ${parseInt(z)}`
    },


    // ugh
    setRotation (a = '', b = '', c = '') {
      if (a) { this.a = parseInt(a) }
      if (b) { this.b = parseInt(b) }
      if (c) { this.c = parseInt(c) }
      if (this.z > -1) {
        this.a = 0
      }
      return `${this.a} ${this.b} ${this.c}`
    },

    // This changes the src property for the correct imageId
    // This is triggered on click event of the Season's button
    onSeasonButton(season)
    {
      // these will trigger a-cylinders to be on the DOM or not
      this.previouslyActiveSeason = this.currentlyActiveSeason
      this.currentlyActiveSeason = season
      // ease in images
      this.transitionSkies()
      this.$gtm.trackEvent({
        event: 'user_event',
        category: this.exhibit.name,
        action: 'View',
        label: this.getNameOfSeason(this.currentlyActiveSeason)
      })
    },

    // A Media Pin has been pressed - present the diaogue overlay
    // with as much text as possible read from the
    onClickPin(pin)
    {

      console.log("Pin pressed", pin)
      this.modaltype = parseInt(pin.pin_type)
      switch(this.modaltype){
        case 1:
          this.modalurl = pin.image.url;
        break;
        case 2:
        this.modalurl = pin.video.url;
        break;
        case 3:
          this.modalurl = pin.audio.url;
        break;
      }
      // this.modalurl =  pin.image.url
      this.modalCaption = pin.image.caption || ''

      this.showModal = true
      this.$gtm.trackEvent({
        event: 'user_event',
        category: this.exhibit.name,
        action: 'Click Pinpoint - ' + this.getNameOfSeason(this.currentlyActiveSeason),
        label: pin.image.title
      })
    },

    onCloseDialogue()
    {
      this.showModal = false
    }

  },
  mounted () {

    this.parseData()

    /* useful Tool. DON'T EVEN THINK OF DELETING IT */
    /*window.addEventListener('keydown', (event) => {
      console.log(event)
      switch (event.code) {
        case 'KeyQ':
          this.a += 0.5
          break

        case 'KeyA':
          this.a -= 0.5
          break

        case 'KeyW':
          this.b += 0.5
          break

        case 'KeyS':
          this.b -= 0.5
          break

        case 'KeyE':
          this.c += 0.5
          break

        case 'KeyD':
          this.c -= 0.5
          break

        case 'ArrowUp':
          this.y += 0.5
          break

        case 'ArrowDown':
          this.y -= 0.5
          break

        case 'ArrowLeft':
          this.x -= 0.5
          break

        case 'ArrowRight':
          this.x += 0.5
          break

        case 'Numpad8':
          this.z += 0.5
          break

        case 'Numpad2':
          this.z -= 0.5
          break
      }
      console.log({x: this.x, y: this.y, z: this.z}, {a: this.a, b: this.b, c: this.c})
    })*/
    this.$gtm.trackEvent({
      event: 'user_event',
      category: this.exhibit.name,
      action: 'View Season',
      label: this.getNameOfSeason(this.currentlyActiveSeason)
    })
  },

  // Components are other VUE elements
  components: {
    Dialogue
  }
}
</script>

<style lang="scss" scoped>
section {
  padding: 30px;
}
.season {
  height: 100%;
  overflow:auto;
}
.top {
  padding: 10px;
  display: flex;
  justify-content: space-between;
  position: relative;
  z-index: 20;
}


/*** HEADER ***/
header {
    background-color: black;
    color: white;
    padding: 30px;
    display: flex;
}
header .fimg {
    width: 25%;
}
header h1 {
    font-family: "akzidenz-grotesk", Helvetica, Arial, sans-serif;
    font-size: 1.3rem;
    font-weight: bold;
    letter-spacing: 1px;
    text-transform: capitalize;
    margin: 0;
    text-align: left;
}
header h2 {
    text-transform: uppercase;
    margin: 0;
    font-size: 0.7em;
    font-weight: normal;
    text-align: left;
}
header .header-copy {
    // align-self: center;
    letter-spacing: 2px;
    flex: 1;
    align-self: center;
    padding-left: 15px;
}

section.g-about h3 {
    text-transform: uppercase;
    font-weight: normal;
    text-align: center;
}

/*** BUTTONS ***/
#season-btns {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100px;
  text-align: center;
  user-select: none;
}

// Seasons' selection
#season-btns button {
  border: 4px solid white;
  background-color: rgba(100, 100, 100, 0.4);
  color: white;
  height: 80px;
  width: 80px;
  margin-left: 15px;
  margin-right: 15px;
  margin-top: 10px;
  margin-bottom: 10px;
  font-size: 13px;
  border-radius: 50%;
  user-select: none;
  cursor: pointer;

  // Super bad for accessibility
  &:focus {
    outline: none;
  }

  &:disabled{
    //@at-root
    //opacity: 0.5;
    cursor:not-allowed;

  }

  &.active{
    background-color: rgba(0, 0, 0, 1);
  }

}
#btn-summer {
  padding: 2px;
}

.modal{
  z-index:9999999;
}
.debug{
  position:absolute;
  top:50px;
  left:0;
  right:0;
  z-index:99;
  font-weight:bold;
  text-shadow:white 0 0 2px;
  user-select:none;
  text-align:left;
}


</style>
